<template>
  <el-dialog
    title="Entre em contato com o suporte"
    center
    append-to-body
    :visible.sync="modal"
  >
    <span class="lead text-center">Escolha uma das opções abaixo</span>
    <span slot="footer" class="dialog-footer">
      <button class="btn btn-info text-white">
        <a href="https://m.me/toptraderorg" target="_blank" class="text-white">
          <i class="fab fa-facebook">Facebook</i>
        </a>
      </button>
      <button class="btn btn-success">
        <a href="https://api.whatsapp.com/send?phone=5591991133258" target="_blank">
          <i class="fab fa-whatsapp">Whatsapp</i>
        </a>
      </button>
    </span>
  </el-dialog>
</template>

<script>
import { Dialog, Table, TableColumn, MessageBox } from "element-ui";

export default {
  components: {
    [Dialog.name]: Dialog,
  },
  props: {
    modal: Boolean
  }
  // data: () => ({
  //   modal: false
  // })
}
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/pages/Dashboard/Pages/HelpPremium.vue